import { useEffect, useState } from "react";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";

export const useIndividualNews = (slug) => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  const getEvent = async () => {
    try {
      const response = await postApi(apiEndPoints.getIndividualNews, { slug });
      if (response && response.status === 200) {
        setEvent(response.data?.data);
      }
    } catch (err) {
      console.error("Error fetching individual news:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) {
      getEvent();
    }
  }, [slug]);

  return { event, loading };
};